<template>
  <div
    class="sprouter"
    :class="{ disabled: disabled }"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div class="sprouter-img"><img v-bind:src="img" /></div>
    <div class="name" :class="{ active: isActive, lighten: lighten }">
      {{ name }}
    </div>
    <div class="position">{{ position }}</div>
    <div v-show="isActive" class="triangle"></div>
  </div>
</template>

<script>
export default {
  name: "Sprouter",
  props: ["isActive", "img", "name", "position", "disabled"],
  data: function () {
    return {
      hover: false,
    };
  },
  computed: {
    lighten: function () {
      if (this.hover) {
        if (this.isActive) {
          return false;
        }
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped 
       lang="scss">
@import "../../static/styles/palette.scss";

.sprouter {
  display: inline-block;
  position: relative;
  margin: 30px 0 10px;
  min-width: 280px;
  height: 390px;
  text-align: center;
  cursor: pointer;
  z-index: 10;

  & .sprouter-img {
    position: relative;
    width: 240px;
    height: 230px;
    margin: 0 auto;
    
    & img {
      object-fit: cover;
      max-width: 100%;
      height: 100%;
    }
  }

  & .name {
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    min-width: 135px;
    padding: 0 2px;
    height: 30px;
    margin: 20px auto 10px;
    border-style: solid;
    border-width: 4px;
    border-color: $darkGray;
    font-family: "Fugaz One";
    font-size: 19px;
    letter-spacing: 3.4px;
    color: $darkGray;
  }
  & .name.lighten {
    color: white;
    background-color: $darkGray;
    opacity: 0.75;
  }
  & .name.active {
    color: white;
    background-color: $darkGray;
  }

  & .position {
    font-family: "Fugaz One";
    font-size: 18px;
    letter-spacing: 1.3px;
    margin: 0 auto;
    max-width: 250px;
  }

  & .triangle {
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 30px 30px 0 30px;
    border-color: white transparent transparent transparent;
    bottom: 0;
    left: calc(50% - 30px);
  }
}
.sprouter.disabled {
  opacity: 0.3;
  cursor: auto;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// Sprouter.vue?5513cb6e